// extracted by mini-css-extract-plugin
export default {"wrapper":"bulkSpareDetailPage_wrapper__DlgID","box":"bulkSpareDetailPage_box__Ysl23","box__section":"bulkSpareDetailPage_box__section__Oi67q"};